import { MONTHS } from '../../../../constants';
import { getDaysInMonth, getFirstDayOfMonth } from '../../../../utils';

export default function YearView({ year, onSelectMonth, isMobile }) {
    return (
        <div className={`year-grid ${isMobile ? 'mobile' : ''}`}>
            {MONTHS.map((m, mi) => {
                const daysInMonth = getDaysInMonth(year, mi);
                const firstDay = getFirstDayOfMonth(year, mi);
                const cells = [];
                for (let i = 0; i < firstDay; i++) cells.push(null);
                for (let d = 1; d <= daysInMonth; d++) cells.push(d);

                return (
                    <div key={m}
                        onClick={() => onSelectMonth(mi)}
                        className="year-month-card"
                    >
                        <div className={`year-month-title ${isMobile ? 'mobile' : ''}`}>{m}</div>
                        <div className="year-month-grid">
                            {cells.slice(0, 35).map((d, i) => {
                                if (!d) return <div key={i} className={`year-day-cell ${isMobile ? 'mobile' : ''}`} />;
                                const today = new Date();
                                const isToday = new Date(year, mi, d).toDateString() === today.toDateString();
                                return (
                                    <div key={i} className={`year-day-cell ${isMobile ? 'mobile' : ''} ${isToday ? 'today' : ''}`}>
                                        {d}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
